import { render } from "./VideoMonitoring.vue?vue&type=template&id=a005c6a0&scoped=true"
import script from "./VideoMonitoring.vue?vue&type=script&lang=js"
export * from "./VideoMonitoring.vue?vue&type=script&lang=js"

import "./VideoMonitoring.vue?vue&type=style&index=0&id=a005c6a0&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a005c6a0"]])

export default __exports__